import React from 'react';

export default function PredictionChart() {
  // Simplified chart representation
  return (
    <div className="h-64 flex items-end space-x-2">
      {[65, 70, 68, 75, 78, 80, 82].map((value, index) => (
        <div key={index} className="flex-1 flex flex-col items-center">
          <div 
            className="w-full bg-blue-200 rounded-t"
            style={{ height: `${value}%` }}
          />
          <span className="text-xs text-gray-500 mt-2">W{index + 1}</span>
        </div>
      ))}
    </div>
  );
}